import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const FaqsModule = lazy(loadModule);

export default FaqsModule;
